import { components, MenuProps, GroupBase } from "react-select";
import classNames from "classnames";

type MenuOverrideProps<OptionType> = MenuProps<OptionType, false, GroupBase<OptionType>> & {
	// Stable, non-hashed class derived from data-testid (DS-014 mechanism), extended here since
	// the menu is portaled outside the field's own DOM.
	stableClassName?: string;
};

// Adds a stable, non-hashed class to react-select's own generated menu markup — same role as
// AdvancedSelectFormik's own Menu override, renamed to this component's own prefix.
const Menu = <OptionType,>({
	children,
	stableClassName,
	...props
}: MenuOverrideProps<OptionType>) => (
	<components.Menu className={classNames("react-select-field-menu", stableClassName)} {...props}>
		{children}
	</components.Menu>
);

export { Menu };
